function deliveryPageScripts() {
	var nextArrow = '/wp-content/themes/rhubarb-duplo/library/images/slider-next.svg';
	var prevArrow = '/wp-content/themes/rhubarb-duplo/library/images/slider-prev.svg';

	$('.js__grid-slider').slick({
		dots: false,
		arrows: true,
		nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ nextArrow +");'></div>",
		prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ prevArrow +");'></div>",		
		mobileFirst: true,
		slidesToShow: 1,
		responsive: [
			{
				breakpoint: 575,
		      	settings: {
		        	slidesToShow: 2
		      	}
			},
			{
				breakpoint: 767,
		      	settings: {
		        	slidesToShow: 3
		      	}
			},
			{
				breakpoint: 991,
		      	settings: {
		        	slidesToShow: 4
		      	}
			}
		]	
	});	
}